import { SET_CURRENT_CUSTOMER } from 'actions';
import { ICurrentCustomerFieldsFragment } from 'typings/GraphQL';

export function setCurrentCustomer(
  currentCustomer?: ICurrentCustomerFieldsFragment,
) {
  return { currentCustomer, type: SET_CURRENT_CUSTOMER };
}
